export const upcomingBookings = () => {
  const root = document.querySelectorAll("[js-upcoming-bookings]");

  if (root) {
    root.forEach((innerRoot) => {
      const cta = innerRoot.querySelector(
        "[js-upcoming-bookings-cta]"
      ) as HTMLElement;
      const list = innerRoot.querySelector(
        "[js-upcoming-bookings-list]"
      ) as HTMLElement;

      if (cta && list) {
        const childrenItems = list?.querySelectorAll("a");

        cta.addEventListener("click", () => {
          if (list.classList.contains("max-h--0")) {
            // list is currently closed
            list.classList.remove("max-h--0");
            list.style.maxHeight = `${list.scrollHeight}px`;
            cta.setAttribute("aria-expanded", "true");
            childrenItems?.forEach((item) => {
              item.setAttribute("tabindex", "0");
            });
          } else {
            // list is currently open
            list.style.removeProperty("max-height");
            list.classList.add("max-h--0");
            cta.setAttribute("aria-expanded", "false");
            childrenItems?.forEach((item) => {
              item.setAttribute("tabindex", "-1");
            });
          }
        });
      }
    });
  }
};
